"use client";
import React from "react";
import sparkle from '../../assets/advanced/sparkle.png';
import footprints from '../../assets/advanced/image.png';
import background from '../../assets/howto/background.png'
import Grid from '@mui/material/Grid2';
import { Box, Typography, useTheme } from "@mui/material";

const AdvancedPayment: React.FC = () => {

    const theme = useTheme();

    return (
        <Box component="section" sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            maxWidth: "1320px",
            margin: "0 auto",
            width: "100%",
            px: 1.5,
            gap: "32px",
            flexWrap: "wrap",
        }}>
            <Box sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: {xs:"flex-start", md: "center"},
                justifyContent: "flex-start",
                flexWrap: "wrap",
            }}>
                <Typography
                    component="span"
                    variant="subtitle8"
                    sx={{
                        color: theme.palette.darkPurple[500],
                        textTransform: "uppercase",
                    }}
                >
                    Advanced
                    <Box component="span" sx={{
                        color: theme.palette.lightPurple[500]}}>
                        {" "}payment <br/>
                    </Box>
                    gateway services
                </Typography>
            </Box>

            <Grid container spacing={1} sx={{
                alignItems: {xs:"flex-start", md: "center"},
                display: "flex",
                flexDirection: {xs:"column", sm: "row", md: "row" },
                gap: "6px",
                alignSelf: "stretch",
            }}>
                <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{
                    alignItems: "flex-start",
                    display: "flex",
                    gap: {md: "30px", xs: "64px"},
                    flex: "1 0 0",
                    alignSelf: "stretch",
                    padding: "20px",
                    borderRadius: "12px",
                    position: "relative",
                    backgroundColor: theme.palette.darkPurple[500],
                    flexDirection: "column",
                }}>
                    <Box
                        component="img"
                        src={background}
                        alt="Background"
                        sx={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "12px",
                            inset: 0,
                            position: "absolute",
                            display: "flex",
                        }}
                    />
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        gap: { xs: "64px"},
                        position: "relative",
                    }}>
                        <Box sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            gap: "10px",
                            alignSelf: "stretch",
                        }}>
                            <Typography component="span" variant={"h2"} sx={{
                                color: theme.palette.beige[100]
                            }}>
                                80
                                <Typography component="span" variant="subtitle10" sx={{
                                    color: theme.palette.beige[100]
                                }}>
                                    %
                                </Typography>
                            </Typography>
                            <Typography variant="subtitle3" sx={{
                                color: theme.palette.beige[100],
                                textTransform: "uppercase",
                            }}>
                                Success Rate Over
                            </Typography>
                        </Box>
                    </Box>
                    <Box sx={{
                        display: "flex",
                        width: {md: "80px", xs: "60px"},
                        height: {md: "80px", xs: "60px"},
                        justifyContent: "center",
                        alignItems: "center",
                        flexShrink: 0,
                        borderRadius: "12px",
                        position: "relative",
                        flexDirection: "column",
                        backgroundColor: theme.palette.lime[100],
                    }}>
                        <Box component="img" src={sparkle} alt="Sparkle" sx={{
                             width: {xs: "36px", md: "48px"},
                             height: {xs: "36px", md: "48px"},
                            objectFit: "cover",
                            borderRadius: "12px",
                        }} />
                    </Box>
                </Grid>

                <Grid size={{ xs: 12, sm: 12, md: 6 }} sx={{
                    alignItems: "center",
                    display: "flex",
                    gap: "30px",
                    flex: "1 0 0",
                    alignSelf: "stretch",
                    padding: "20px",
                    minHeight: "256px",
                    borderRadius: "12px",
                    backgroundColor: theme.palette.gray[200],
                }}>
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        flex: 1,
                        alignSelf: "stretch",
                    }}>
                        <Box sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            alignSelf: "stretch",
                        }}>
                            <Typography variant="subtitle3" sx={{
                                color: theme.palette.darkPurple[500],
                                textTransform: "uppercase",
                            }}>
                                Routing <br />
                                And cascading
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: "flex",
                            alignItems: "flex-end",
                            justifyContent: "space-between",
                            alignSelf: "stretch",
                            gap: "30px"
                        }}>
                            <Box sx={{
                                display: "flex",
                                width: {md: "80px", xs: "60px"},
                                height: {md: "80px", xs: "60px"},
                                justifyContent: "center",
                                alignItems: "center",
                                flexShrink: 0,
                                borderRadius: "12px",
                                position: "relative",
                                flexDirection: "column",
                                backgroundColor: theme.palette.lightPurple[400],
                            }}>
                                <Box component="img" src={footprints} alt="Foot prits" sx={{
                                    width: {xs: "36px", md: "48px"},
                                    height: {xs: "36px", md: "48px"},
                                    objectFit: "cover",
                                    borderRadius: "12px",
                                }} />
                            </Box>
                            <Typography variant="body4" sx={{ 
                                color: theme.palette.gray[400],
                                textTransform: "uppercase",
                                }}>
                                    Maximize transaction success <br />
                                    rates with intelligent payment <br />
                                    routing and failover mechanisms
                                </Typography>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AdvancedPayment;
